import React, { useEffect, useState } from 'react';
import { TabHeader } from '@components/TabHeader';
import type { TabsProps } from '@components/main-components/tabs/Tab';
import type { TopChartsType } from '@pages-shared/topCharts';
import type { ViralChartsType } from '@pages-shared/viralCharts';

const ChartTabsOptions = {
  VIRAL: 'viral',
  TOP: 'top',
} as const;

export type ChartTabsType = (typeof ChartTabsOptions)[keyof typeof ChartTabsOptions];
const ChartTabsValues = Object.values(ChartTabsOptions);

export interface ChartProps {
  chartType: ChartTabsType;
  contentType: TopChartsType | ViralChartsType;
}

export function ChartTabs({
  onSelection,
  value,
  icons,
}: TabsProps & {
  icons: JSX.Element;
  onSelection?: (value: ChartTabsType) => void;
}) {
  const [debouncedValue, setDebouncedValue] = useState<string>(value || ChartTabsOptions.VIRAL);

  useEffect(() => {
    onSelection?.(debouncedValue as ChartTabsType);
  }, [debouncedValue, onSelection, value]);

  return (
    <TabHeader
      tabs={ChartTabsValues.map(ctv => ({
        text: ctv,
        active: value === ctv,
        onClick: () => setDebouncedValue(ctv),
      }))}
      rightContent={<div className="-mx-2">{icons}</div>}
    />
  );
}
